import React from 'react';
import ProfileMenu from './ProfileMenu';
import './FiscalInterface.css';
import { connect } from 'react-redux';


class Header extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

	        let logoSrc = this.props.faculdade.logo;
	        return (
            <div className="topbar fiscal-app-header" id="header_page" style={{position:this.props.sala_screen==true?'absolute':'fixed'}}>

                <div className="topbar-left fiscal-header-brand">
	                    {this.props.faculdade.logo != null && <a className="logo fiscal-header-logo">
	                        <span>
	                            <img src={logoSrc} alt="" height='70' />
	                        </span>
	                        <i>
	                            <img className="img-fluid" src={logoSrc} alt="" style={{height:70,objectFit:'contain'}} />
	                        </i>
	                    </a>}
                </div>
                <nav className="navbar-custom fiscal-header-nav">
                    <ul className="navbar-right fiscal-header-actions d-flex list-inline float-right mb-0">
                                                <ProfileMenu />

                    </ul>

                </nav>
            </div>

        );
    }


}

const mapsStateToProps = (state) => (
    {
        faculdade: state.AppReducer.faculdade,
    sala_screen: state.AppReducer.sala_screen,

    }
);

export default connect(mapsStateToProps, {})(Header);